import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M7 7h-1a2 2 0 0 0 -2 2v6a2 2 0 0 0 2 2h10.52a1 1 0 0 0 .394 -.081m1.86 -2.137l2.226 -2.782l-3.7 -4.625a1 1 0 0 0 -.78 -.375h-5.52","key":"svg-0"}],["path",{"d":"M3 3l18 18","key":"svg-1"}]]

const IconLabelOff = createReactComponent('outline', 'label-off', 'LabelOff', __iconNode);

export default IconLabelOff;